module.exports = __webpack_public_path__ + "img/79.2800a653.jpg";